module.exports = __webpack_public_path__ + "static/media/6.0e24c719.png";